import { useState } from "react";

import { gtmService } from "@/services/gtm-service";
import { useAuthStore } from "@/store/auth.store";

interface Params {
  onSuccess: () => void;
}

export const useSignIn = ({ onSuccess }: Params) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, isLoading, error, clearError } = useAuthStore();

  const isValid = !!email && !!password;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    if (!isValid) return;
    try {
      gtmService.trackLogInTry({ type: "basic", email });
      await login(email, password);
      gtmService.trackLogInScs({ type: "basic", email });
      onSuccess();
    } catch (err) {
      gtmService.trackLogInFail({
        type: "basic",
        email,
        error: err instanceof Error ? err.message : "unknown",
      });
      // error is in store
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    handleSubmit,
    isLoading,
    isValid,
    error,
  };
};
